<template>
    <div class="weekly-functional-test-index">
        <weekly-functional-test-row
            v-for="weeklyFunctionalTest in weeklyFunctionalTests"
            :key="weeklyFunctionalTest.id"
            :form="weeklyFunctionalTest"
            @click="gotoweeklyFunctionalTest(weeklyFunctionalTest)"
        />
        <button
            class="engineer-load-more btn btn-primary"
            v-if="page < lastPage"
            @click="loadMore"
        >
            Load More
        </button>
        <button
            class="btn floating-new-btn"
            @click="newweeklyFunctionalTest"
        >
            <i class="fa fa-plus" />
        </button>
        <button
            class="btn floating-refresh-btn"
            @click="reload"
        >
            <i
                class="fas fa-sync-alt"
                :class="{'fa-spin' : loading}"
            />
        </button>
    </div>
</template>

<script>
import Service from '../../services/FormService';
import WeeklyFunctionalTestRow from './WeeklyFunctionalTestRow';

export default {
    components: {
        WeeklyFunctionalTestRow,
    },
    data () {
        return {
            loading: false,
            weeklyFunctionalTests: [],
            page: 1,
            lastPage: 1,
        };
    },
    mounted () {
        this.load();
    },
    methods: {
        reload() {
            this.page = 1;
            this.weeklyFunctionalTests = [];
            this.load();
        },
        load () {
            this.loading = true;
            Service.search({
                page: this.page,
                type: 'weekly_functional_test'
            }).then(res => {
                this.weeklyFunctionalTests = [...this.weeklyFunctionalTests, ...res.data.data];
                this.lastPage = res.data.last_page;
                window.setTimeout(() => {
                    this.loading = false;
                }, 1000);
            }).catch(err => {
                console.error(err);
                this.setErrorMessage('Failed to load weekly functional tests');
            });
        },
        loadMore() {
            ++this.page;
            this.load();
        },
        gotoweeklyFunctionalTest (form) {
            this.$router.push({ name: 'engineer.forms.edit', params: {id: form.id} })
        },

        newweeklyFunctionalTest () {
            this.$router.push({ name: 'engineer.forms.new', query: {type: 'weekly_functional_test'} })
        },
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/WeeklyFunctionalTests.vue